m = require 'mithril'
StoreFactory 	= require './state/StoreFactory'
ActionFactories = require './state/ActionFactories'
Routes 			= require './ui/Routes'

# Init store
store = StoreFactory()

# Trigger initial data load
store.dispatch ActionFactories.gamesLoaded []

# Init UI
m.route.mode = 'hash'
m.route document.getElementById('app'), Routes.defaultRoute, Routes.generate store